import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    selectableText: {
        WebkitUserSelect: 'auto',
        MozUserSelect: 'auto',
        msUserSelect: 'auto',
        userSelect: 'auto'
    }
});

export interface ISelectableTextProps {
    children: ReactNode;
}

export const SelectableText: FC<ISelectableTextProps> = ({ children }) => {
    const classes = useStyles();

    return (
        <div className={classes.selectableText}>
            {children}
        </div>
    );
};
